import React from "react";
import { TablePagination } from "@mui/material";
import { CircularLoader, CustomButton, HorizontalDivider, LimitedTextField } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import styles from "../ImportHeritagePanel.module.css";

const RightPanel = ({
	phase,
	rightDeliverables,
	isLoadingRight,
	rightPage,
	rightPerPage,
	rightTotalCount,
	onPageChange,
	onRowsPerPageChange,
	searchRight,
	onSearchChange,
	checkedRight,
	onToggleRight,
	onSelectAllRight,
	searchFieldSx,
}) => (
	<div className={`${styles.panel} ${styles.rightPanel}`}>
		<div className={styles.header}>
			<span className={styles.headerTitle}>{translate("project-phases.associated.target-phase-title")}</span>
		</div>
		<div className={styles.controls}>
			<span className={styles.phaseName}>{phase?.name}</span>
			<span className={styles.badge}>
				{translate("project-phases.deliverables.count", { count: rightDeliverables.length })}
			</span>
		</div>
		<HorizontalDivider className={`${styles.panelDivider} ${styles.rightDivider}`} />
		<div className={styles.controlsRight}>
			<LimitedTextField
				fullWidth
				containerClassName={styles.textField}
				placeholder={translate("project-phases.strategy-import.search.target")}
				showCounter={false}
				size="medium"
				sx={searchFieldSx}
				value={searchRight}
				onChange={onSearchChange}
			/>
		</div>
		<div className={styles.selectionInfo}>
			<span>
				{translate("project-phases.strategy-import.selected-target-deliverables", {
					count: Object.values(checkedRight).filter(Boolean).length,
				})}
			</span>
			<CustomButton color="primary" variant="text" onClick={onSelectAllRight}>
				{translate("project-phases.strategy-import.select-all")}
			</CustomButton>
		</div>
		<div className={styles.listWrapper}>
			<div className={styles.listContainer}>
				{isLoadingRight ? (
					<div className={styles.loader}>
						<CircularLoader size={24} />
					</div>
				) : (
					rightDeliverables.map((d) => (
						<div key={d.id} className={styles.listItem}>
							<input
								checked={!!checkedRight[d.id]}
								className={styles.checkboxInput}
								id={`right-${d.id}`}
								type="checkbox"
								onChange={() => onToggleRight(d.id)}
							/>
							<label className={styles.listItemLabel} htmlFor={`right-${d.id}`} title={d.name}>
								{d.name}
							</label>
						</div>
					))
				)}
			</div>
			<TablePagination
				component="div"
				count={rightTotalCount}
				labelRowsPerPage={translate("common:pagination.row-per-page")}
				page={rightPage}
				rowsPerPage={rightPerPage}
				rowsPerPageOptions={[15, 25, 50]}
				onPageChange={(_, newPage) => onPageChange(newPage)}
				onRowsPerPageChange={(e) => {
					onRowsPerPageChange(Number(e.target.value));
					onPageChange(0);
				}}
			/>
		</div>
	</div>
);

export default RightPanel;
